module.exports = __webpack_public_path__ + "static/media/order.467de03b.jpeg";